import { Route, Routes } from 'react-router-dom';
import { content } from '../../components/content';
import { Wrapper } from './PageLabs.style';

export type PageLabsProps = {};

export function PageLabs(_props: PageLabsProps) {
  return (
    <Wrapper className='PageLabs-wrapper' data-testid='PageLabs-wrapper'>
      <Routes>
        <Route path='/realtime' element={<content.Realtime />} />
        <Route path='/analytics' element={<content.Analytics />} />
        <Route path='/asset-pack-builder' element={<content.AssetPackBuilder />} />
        <Route path='/hero-generator' element={<content.HeroGenerator />} />
        <Route path='/text-to-instance' element={<content.TextToInstance />} />
        <Route path='/three' element={<content.Three />} />
        <Route path='/material-studio' element={<content.MaterialStudio />} />
        <Route path='/fusion' element={<content.Fusion />} />
        <Route path='/style-transfer' element={<content.StyleTransfer />} />
        <Route path='/image-to-3d' element={<content.ImageTo3d />} />
        <Route path='/image-to-3d/:stage' element={<content.ImageTo3d />} />
        <Route path='/text-to-3d' element={<content.TextTo3d />} />
        <Route path='/text-to-3d/:stage' element={<content.TextTo3d />} />
        <Route path='/goldens' element={<content.Goldens />} />
        <Route path='/quality' element={<content.Quality />} />
        <Route path='/guassian' element={<content.Guassian />} />
        <Route path='/alpha' element={<content.Invitation />} />
        <Route path='/' element={<content.ImageTo3d />} />
      </Routes>
    </Wrapper>
  );
}

export default PageLabs;
